import { RoutesConst } from '@carm/shared/constants/const-routes';
import { RulingStepPageShortDescription, RulingSteps, RulingType } from './ruling-enums.model';

export interface IRulingContextForm {
  type: string;
  portEntry: string;
  portEntryText?: string; //?
  subjectRuling: string;
  subjectStatement: string;
  hasVerificationOfTariffClassification: boolean;
  hasAdministrativeReviewOrAppeal: boolean;
  hasJudicialReview: boolean;
  hasRequestForARorNCR: boolean;
  isPreviouslyImported: boolean;
  continueImported: boolean;
  consentReleasePublic: boolean;
  status?: string;   // !BE Mapping result json already StatusName + StatusCode available. Need this property?
}

export const mapRulingTypeToStepLabel = new Map();
mapRulingTypeToStepLabel.set(RulingType.VALUATION, RulingSteps.Valuation);
mapRulingTypeToStepLabel.set(RulingType.TARIFF_CLASSIFICATION, RulingSteps.TariffClassification);
mapRulingTypeToStepLabel.set(RulingType.ORIGIN, RulingSteps.Origin);
mapRulingTypeToStepLabel.set(RulingType.NON_FTA_ORIGIN, RulingSteps.NonFtaOrigin);
mapRulingTypeToStepLabel.set(RulingType.MARKING, RulingSteps.Marking);
mapRulingTypeToStepLabel.set(RulingType.NON_FTA_MARKING, RulingSteps.NonFtaMarking);
mapRulingTypeToStepLabel.set(RulingType.CITT_TEXTILE_TARIFF_RELIEF_INVESTIGATION, RulingSteps.CittTextileTariffReliefInvestigation);
mapRulingTypeToStepLabel.set(RulingType.SAME_CONDITION, RulingSteps.SameCondition);

export const mapRulingTypeToUrl= new Map([
  [RulingType.VALUATION, RoutesConst.Rulings_Step_Valuation_Rel],
  [RulingType.TARIFF_CLASSIFICATION, RoutesConst.Rulings_Step_TariffClassification_Rel],
  [RulingType.ORIGIN, RoutesConst.Rulings_Step_Origin_Rel],
  [RulingType.NON_FTA_ORIGIN, RoutesConst.Rulings_Step_NonFtaOrigin_Rel],
  [RulingType.MARKING, RoutesConst.Rulings_Step_Marking_Rel],
  [RulingType.NON_FTA_MARKING, RoutesConst.Rulings_Step_NonFtaMarking_Rel],
  [RulingType.CITT_TEXTILE_TARIFF_RELIEF_INVESTIGATION, RoutesConst.Rulings_Step_CittTextileTariffReliefInvestigation_Rel],
  [RulingType.SAME_CONDITION, RoutesConst.Rulings_Step_SameCondition_Rel]
]);

export const mapUrlSegmentToRulingStep = new Map([
  [RoutesConst.Rulings_Step_Context_Rel, RulingSteps.RulingContext ],
  [RoutesConst.Rulings_Step_Valuation_Rel, RulingSteps.Valuation ],
  [RoutesConst.Rulings_Step_TariffClassification_Rel, RulingSteps.TariffClassification ],
  [RoutesConst.Rulings_Step_Origin_Rel, RulingSteps.Origin ],
  [RoutesConst.Rulings_Step_NonFtaOrigin_Rel, RulingSteps.NonFtaOrigin ],
  [RoutesConst.Rulings_Step_Marking_Rel, RulingSteps.Marking ],
  [RoutesConst.Rulings_Step_NonFtaMarking_Rel, RulingSteps.NonFtaMarking, ],
  [RoutesConst.Rulings_Step_CittTextileTariffReliefInvestigation_Rel, RulingSteps.CittTextileTariffReliefInvestigation ],
  [RoutesConst.Rulings_Step_SameCondition_Rel, RulingSteps.SameCondition ]
]);

export const mapRulingTypeToRulingStep = new Map([
  [RulingType.VALUATION, RulingSteps.Valuation],
  [RulingType.TARIFF_CLASSIFICATION, RulingSteps.TariffClassification],
  [RulingType.ORIGIN, RulingSteps.Origin],
  [RulingType.NON_FTA_ORIGIN, RulingSteps.NonFtaOrigin],
  [RulingType.MARKING, RulingSteps.Marking],
  [RulingType.NON_FTA_MARKING, RulingSteps.NonFtaMarking],
  [RulingType.CITT_TEXTILE_TARIFF_RELIEF_INVESTIGATION, RulingSteps.CittTextileTariffReliefInvestigation],
  [RulingType.SAME_CONDITION, RulingSteps.SameCondition],
]);


export const mapRulingStepToRulingDescription = new Map([
  [RulingSteps.RulingContext, RulingStepPageShortDescription.RulingContext ],
  [RulingSteps.Valuation, RulingStepPageShortDescription.Valuation ],
  [RulingSteps.TariffClassification, RulingStepPageShortDescription.TariffClassification ],
  [RulingSteps.Origin, RulingStepPageShortDescription.Origin ],
  [RulingSteps.NonFtaOrigin, RulingStepPageShortDescription.NonFtaOrigin ],
  [RulingSteps.Marking, RulingStepPageShortDescription.Marking ],
  [RulingSteps.NonFtaMarking, RulingStepPageShortDescription.NonFtaMarking, ],
  [RulingSteps.CittTextileTariffReliefInvestigation, RulingStepPageShortDescription.CittTextileTariffReliefInvestigation ],
  [RulingSteps.SameCondition, RulingStepPageShortDescription.SameCondition ]
]);
